// Standard library imports
import React, { useState } from 'react';
// Internal module imports
import TabsComponent from '../../../components/Tabs/Tabs';
import EicSignalLogs from './EicSignalLogs';
import { useQueryParamWithDefault } from '../../../hooks';
import { NumberParam } from 'use-query-params';

const EICSignalIndex = ({ eicCode, cId }) => {
    const [selectedIndex, setSelectedIndex] = useQueryParamWithDefault('subTab', NumberParam, 0, cId);

    let tabs = [
        {
            name: 'DK1 Signal Logs',
            component: (
                <>
                    <EicSignalLogs eicCode={eicCode} area={'DK1'} cId={cId} />
                </>
            ),
            tabId: 1,
        },
        {
            name: 'DK2 Signal Logs',
            component: (
                <>
                    <EicSignalLogs eicCode={eicCode} area={'DK2'} cId={cId} />
                </>
            ),
            tabId: 1,
        },
    ];

    return (
        <div className=" ventilation">
            <TabsComponent
                selectedIndex={selectedIndex}
                tabs={tabs}
                onChangeTab={(index) => {
                    setSelectedIndex(index);
                }}
                cId={cId}
            />
        </div>
    );
};

export default EICSignalIndex;
